{
  "notifications": "Notifications",
  "send-new": "Send new",
  "compose": "Compose",
  "select-recipients": "Select recipients",
  "no-matching-contacts": "No matching contacts",
  "template": "Template",
  "subject": "Subject",
  "to": "To",
  "cc": "CC",
  "bcc": "BCC",
  "reply-to": "Reply To",
  "send": "Send",
  "message": "Message",
  "options": "Options",
  "date": "Date and Time",
  "sender": "Sender",
  "recipients": "Recipients",
  "status": "Status",
  "status-sent": "Sent",
  "from": "From",
  "send-notification": "Notification has been sent",
  "view-message": "View message",
  "no-notifications": "No notifications have been sent for this order yet.",
  "preview": "Preview"
}
